export default __webpack_public_path__ + "static/media/tickedComanda.183b979f.png";